<ng-template #sheetTemp>
    <div *ngIf="previewSheetData" class="preview-container">
        <span>
            <div class="head-section">
                <div class="d-flex flex-row justify-content-between mb-4">
                    <div class="d-flex flex-column">
                        <div class="d-flex">
                            <div class="mat-body-2 text-black mb-4">{{previewSheetData.title}}</div>
                        </div>
                        <div class="mat-subtitle-2 text-hint mb-4" *ngIf="previewSheetData?.timezone">
                            {{generalMessages.TIMEZONE_NOTE}}
                            <span class="secondary-text">{{previewSheetData.timezone?.timezone_label}} ({{previewSheetData.timezone?.timezone_abbr}})</span>
                        </div>
                    </div>

                    <button mat-icon-button (click)="confirmSend()" class="w-24 h-24 cancel-icon">
                        <mat-icon class="text-hint">cancel</mat-icon>
                    </button>
                </div>

                <mat-divider></mat-divider>
                <div class="mb-4"></div>
            
                <ng-container *ngIf="previewSheetData.warnMessage?.length">
                    <mat-card 
                        appearance="outlined" 
                        *ngFor="let warnData of previewSheetData.warnMessage" 
                        [class.error-warn]="warnData?.isErrorType" 
                        class="notify-warn-card mat-elevation-z0 mb-8"
                    >
                        <div class="d-flex align-items-center">
                            <mat-icon>{{(warnData?.isErrorType) ? 'error' : 'warning'}}</mat-icon>
                            <div>
                                <div class="mat-subtitle-2 m-0">
                                  {{warnData?.value}} 
                                  <a 
                                    *ngIf="warnData.buttonMessage" (click)="messageButtonClicked()"
                                    class="mat-body-strong secondary-text cursor-pointer" 
                                  >
                                    {{ warnData.buttonMessage }}
                                  </a>
                                </div>
                                <ul style="margin-top: 8px; margin-bottom: 0px;" *ngIf="!warnData.buttonMessage && warnData?.list?.length">
                                    <ng-container *ngIf="hasGreaterWarnList(warnData?.list) as _warnPreview; else normalWarnListTemp">
                                        <li *ngIf="!moreInstruction" class="mat-subtitle-2 m-0">
                                            <a class="mat-body-strong secondary-text cursor-pointer" (click)="moreInstruction = true"> see more</a>
                                        </li>
                                        <ng-container *ngIf="moreInstruction">
                                            <li class="mat-subtitle-2 m-0" *ngFor="let warnListItem of warnData.list">{{warnListItem}}</li>
                                            <a class="mat-body-strong secondary-text cursor-pointer" (click)="moreInstruction = false">see less</a>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #normalWarnListTemp>
                                        <li class="mat-subtitle-2 m-0" *ngFor="let warnListItem of warnData.list">{{warnListItem}}</li>
                                    </ng-template>
                                </ul>
                            </div>
                        </div>
                    </mat-card>
                </ng-container>
            </div>

            <div class="content-section" [class.hidden]="!previewSheetData?.previewData?.tableContents?.length">
                <app-key-value-response-table 
                    *ngIf="previewSheetData.previewData"
                    [tableData]="previewSheetData.previewData"
                    [pageName]="previewSheetData.pageName"
                ></app-key-value-response-table>
            </div>
        </span>

        <div class="action-section">
            <div class="d-flex align-items-center justify-content-end h-48">
                <button 
                    mat-button 
                    [color]="previewSheetData.actionL?.disabled ? '' : 'accent'" 
                    class="mr-8" 
                    (click)="confirmSend()" 
                    [disabled]="previewSheetData.actionL?.disabled"
                >
                    {{previewSheetData.actionL?.value || 'CANCEL' }}
                </button>
                <button 
                    mat-button 
                    [color]="previewSheetData.actionR?.disabled ? '' : 'accent'" 
                    (click)="confirmSend(true)" 
                    [disabled]="previewSheetData.actionR?.disabled"
                >
                    {{previewSheetData.actionR?.value || 'DONE' }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #dialogTemp>
  <ng-container *ngIf="previewSheetData">

    <mat-dialog-content class="dialog-content">
      <div class="preview-dialog-header">
        <div class="mat-body-1 preview-title">
          Preview {{ previewSheetData.title }}
        </div>
        <div class="mat-subtitle-1 text-hint preview-timezone" *ngIf="previewSheetData?.timezone">
          {{ generalMessages.TIMEZONE_NOTE }}
          <span class="secondary-text">
            {{ previewSheetData.timezone?.timezone_label }} ({{ previewSheetData.timezone?.timezone_abbr }})
          </span>
        </div>
      </div>

      <ng-container *ngFor="let previewRow of previewSheetData.previewData.tableContents">
        <div class="mat-body-1 preview-row-name">
          {{ previewRow.name }}
        </div>
        <div class="mat-subtitle-1 preview-row-value">
          {{ previewRow.value }}
        </div>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
      <button 
        mat-button 
        
        [color]="previewSheetData.actionL?.disabled ? '' : 'accent'" 
        class="action-left mat-button" 
        (click)="confirmSend()" 
        [disabled]="previewSheetData.actionL?.disabled"
      >
        {{ previewSheetData.actionL?.value || 'CANCEL' }}
      </button>

      <button 
        mat-button 
        class="mat-button"
        [color]="previewSheetData.actionR?.disabled ? '' : 'accent'" 
        (click)="confirmSend(true)" 
        [disabled]="previewSheetData.actionR?.disabled"
      >
        {{ previewSheetData.actionR?.value || 'DONE' }}
      </button>
    </mat-dialog-actions>

  </ng-container>
</ng-template>